<script setup>
const { isDesktop, isMobile, isTablet } = useDevice();
import { twMerge } from "tailwind-merge";
import { ref, nextTick, onMounted } from "vue";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
const splideRef = ref(null);

const props = defineProps({
  appendClass: {
    type: String,
    default: "",
    required: false,
  },
});

onMounted(async () => {
  if (import.meta.client) {
    await nextTick();
    if (splideRef.value) {
      new Splide(
        splideRef.value,
        {
          perPage: isMobile ? 1 : isTablet ? 2 : 4,
          gap: "0px",
          type: "loop",
          arrows: false,
          pagination: false,
          drag: false,
          autoScroll: {
            speed: 1,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
        },
        {
          AutoScroll,
        }
      ).mount({ AutoScroll });
    }
  }
});

const aboutUsImgs = ref([
  { image: "/images/AboutImg4.webp", appendClass: "" },
  {
    image: "/images/AboutImg1.webp",
    appendClass: isMobile ? "mt-16" : "mt-24",
  },
  {
    image: "/images/AboutImg2.webp",
    appendClass: isMobile ? "mt-[230px]" : "mt-[238px]",
  },
  {
    image: "/images/AboutImg3.webp",
    appendClass: isMobile ? "mt-[96px]" : "mt-[127px]",
  },
  {
    image: "/images/AboutImg5.webp",
    appendClass: isMobile ? "mt-[130px]" : "mt-[163px]",
  },
  {
    image: "/images/AboutImg6.webp",
    appendClass: isMobile ? "mt-[70px]" : "mt-[100px]",
  },
  {
    image: "/images/AboutImg7.webp",
    appendClass: isMobile ? "mt-[190px]" : "mt-[220px]",
  },
  {
    image: "/images/AboutImg8.webp",
    appendClass: isMobile ? "mt-[120px]" : "mt-[155px]",
  },
  { image: "/images/AboutImg9.webp", appendClass: "" },
  {
    image: "/images/AboutImg10.webp",
    appendClass: isMobile ? "mt-[130px]" : "mt-[163px]",
  },
  {
    image: "/images/AboutImg11.webp",
    appendClass: isMobile ? "mt-[30px]" : "mt-[90px]",
  },
  {
    image: "/images/AboutImg12.webp",
    appendClass: isMobile ? "mt-[180px]" : "mt-[210px]",
  },
  {
    image: "/images/AboutImg13.webp",
    appendClass: isMobile ? "mt-[70px]" : "mt-[105px]",
  },
  { image: "/images/AboutImg14.webp", appendClass: "" },
  {
    image: "/images/AboutImg15.webp",
    appendClass: isMobile ? "mt-[150px]" : "mt-[180px]",
  },
  {
    image: "/images/AboutImg16.webp",
    appendClass: isMobile ? "mt-[80px]" : "mt-[110px]",
  },
  {
    image: "/images/AboutImg17.webp",
    appendClass: isMobile ? "mt-[200px]" : "mt-[230px]",
  },
  {
    image: "/images/AboutImg18.webp",
    appendClass: isMobile ? "mt-[110px]" : "mt-[140px]",
  },
  { image: "/images/AboutImg19.webp", appendClass: "" },
  {
    image: "/images/AboutImg20.webp",
    appendClass: isMobile ? "mt-[140px]" : "mt-[170px]",
  },
]);
</script>

<template>
  <div
    class="max-w-screen-xl mx-auto relative z-10"
    :class="props.appendClass ? props.appendClass : 'xl:pt-10'"
  >
    <h2 class="pt-[54px] mb-2 max-md:mb-4 md:mb-4 text-center">
      <WrGradientText
        append-class="pb-0 pt-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_35.57%,_var(--text-gradient-2)_55.72%)]"
        >Our Story in Pictures</WrGradientText
      >
      Moments that fuel our passion
    </h2>

    <div ref="splideRef" class="splide w-full h-full overflow-hidden">
      <div class="splide__track h-full">
        <ul class="splide__list">
          <li
            class="splide__slide !max-w-max"
            v-for="(card, index) in aboutUsImgs"
            :key="index"
          >
            <div :class="twMerge('min-w-max', card.appendClass)">
              <NuxtImg
                :src="card.image"
                alt="About Us Image"
                height="487"
                width="299"
                loading="lazy"
                format="webp"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
